/**
 * Workstation category icon mapping (Feb 2026)
 *
 * Single source of truth: use-case `slug` -> lucide-react icon name.
 * Rendered as the top-left category badge on:
 *   • Home compact workstation cards           (via ProductCard.icon)
 *   • /workstations product cards              (via ProductCard.icon)
 *   • /workstations/:slug hero image           (rendered inline)
 *
 * Uses the icon library already in the project (lucide-react) — no
 * new dependency. If a slug is not in the map, the badge is not
 * rendered (safer than a mismatched fallback).
 */
export const WORKSTATION_CATEGORY_ICON = {
  business_productivity: "Briefcase",
  content_marketing: "Megaphone",
  creative_design: "Palette",
  architecture_3d: "Box",
};

export const workstationIconForSlug = (slug) =>
  WORKSTATION_CATEGORY_ICON[slug] || null;
